<article class="scan-card" *ngIf="order" [formGroup]="order">
	<div class="scan-card-head">
		<div>
			<strong>{{ cardTitle }}</strong>
			<small *ngIf="cardSubtitle">{{ cardSubtitle }}</small>
		</div>
		<button type="button" class="scan-icon" *ngIf="isNativeOrder" (click)="openOrder()" aria-label="Open order">
			<img class="ao-row-icon" src="assets/images/ao-icon-view.svg" alt="">
		</button>
		<button type="button" class="scan-icon" *ngIf="!isNativeOrder" (click)="editOrder(order.value._id)" [attr.aria-label]="'Edit invoice ' + order.value.invoiceNumber">
			<mat-icon>edit</mat-icon>
		</button>
	</div>

	<div class="scan-preview-wrap">
		<div class="scan-preview" *ngIf="imageCount">
			<app-images
				[images]="order.value.images"
				type="order"
				[productId]="order.value._id"
				(imagesChange)="updateImages($event, order)"
				[autoCrop]="false">
			</app-images>
		</div>
		<button type="button" class="scan-preview native-preview" *ngIf="!imageCount" (click)="openOrder()" aria-label="Open order">
			<div class="native-order-preview">
				<mat-icon>description</mat-icon>
				<span>No scan on file</span>
			</div>
		</button>
		<span class="document-count" *ngIf="imageCount > 1">
			<mat-icon>file_copy</mat-icon>
			{{ imageCount }}
		</span>
		<label class="scan-compare">
			<input type="checkbox" [checked]="selection.isSelected(order)" (change)="toggleSelect(order)">
			Compare
		</label>
	</div>

	<div class="scan-edit" *ngIf="!isNativeOrder && editOrderId == order.value._id">
		<mat-form-field>
			<mat-label>TYPE</mat-label>
			<mat-select formControlName="type">
				<mat-option *ngFor="let typeOption of typeOptions" [value]="typeOption.value">
					{{ typeOption.viewValue }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<mat-label>INVOICE #</mat-label>
			<input matInput formControlName="invoiceNumber" autocomplete="off" (click)="$event.stopPropagation()">
		</mat-form-field>
		<div class="scan-edit-actions">
			<button type="button" (click)="emailOrder($event)">Email</button>
			<button type="button" (click)="setOrderAsPrescription($event)">Set as Rx</button>
			<mat-checkbox formControlName="archived">Hide</mat-checkbox>
		</div>
	</div>

	<div class="scan-actions">
		<button type="button" (click)="printImage(order.value.images)">
			<mat-icon>print</mat-icon>
			Print
		</button>
		<button type="button" [disabled]="order.value.status == 'RETURNED'" (click)="returnOrder($event)">
			<mat-icon>undo</mat-icon>
			Return
		</button>
		<button type="button" [disabled]="order.value.status == 'EXCHANGED'" (click)="exchangeOrder($event)">
			<mat-icon>sync</mat-icon>
			Exchange
		</button>
		<button type="button" class="danger" (click)="deleteOrder($event)">
			<mat-icon>delete</mat-icon>
			Delete
		</button>
	</div>
</article>
